import { render, staticRenderFns } from "./customer-text.vue?vue&type=template&id=54e0c0b2&"
import script from "./customer-text.vue?vue&type=script&lang=js&"
export * from "./customer-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports